import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
const IndustryInteraction = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.industry_interaction, setData);
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Industry Interaction – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Industry Interaction"
          pageName="Industry Interaction"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title="Industry Interaction">
                      Industry Interaction
                    </h3>
                    <h5 title="LIST OF COMPANIES/Institutes for PROJECT WORK">LIST OF COMPANIES/Institutes for PROJECT WORK-</h5>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Name of the Company</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>{obj?.attributes?.Name_of_the_Company}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default IndustryInteraction;
